angular.module('unergie.main')
.controller('launchOperationModalCtrl', ($scope, $timeout, $uibModalInstance, ErrorCatcher, DataAccessRefOrganization, NgTableParams, ApiBilling, DataAccess, AlertManager) => {
    $scope.operations = [{
        value: 'run',
        label: 'Lancer',
    }]
    $scope.organizations = []

    $scope.searchModel = {
        operation: 'run',
        organizations: [],
    }

    $scope.labels = {
        itemsSelected: 'choisies',
        selectAll: 'Tout',
        unselectAll: 'Aucun',
        search: 'Recherche',
        select: 'Choisir',
    }

    DataAccessRefOrganization.getOrganizations().$promise.then((result) => {
        $scope.organizations = result.filter((o) => ['B2G', 'B2B'].includes(o.type)).map((o) => o.id)
    })

    $scope.refreshProcesses = () => DataAccess.searchBatchProcesses({ type: 'META_INVOICE', status: 'ON_GOING' }).$promise.then((onGoingProcesses) => {
        $scope.tableProcesses = new NgTableParams({}, { dataset: onGoingProcesses })
    })

    $scope.refreshProcesses()

    $scope.updateProgress = (process) => {
        process.updating = true
        return DataAccess.refreshBatchProcessProgress({ id: process.id }).$promise.then((result) => {
            AlertManager.success(`Process mis à jour`)
            _.assign(process, _.pick(result, 'progress'))
        })
        .catch(ErrorCatcher)
        .finally(() => {
            process.updating = false
        })
    }

    $scope.launch = () => {
        if ($scope.searchModel.organizations.length === 0) {
            AlertManager.error(`Vous devez renseigner au moins une organisation`)
            return
        }
        $scope.launching = true
        return ApiBilling.runMetaInvoices({ operation: 'run' }, { organizations: $scope.searchModel.organizations }).$promise.then((result) => {
            AlertManager.success(`Lancement en masse démarré`)
            $scope.refreshProcesses()
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.launching = false
        })
    }

    $scope.close = $uibModalInstance.close
})
